module.exports = __webpack_public_path__ + "img/Doo.504e541e.png";